// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGivePatientConsentResponse {
    static getAttributeTypeMap() {
        return MangoHubGivePatientConsentResponse.attributeTypeMap;
    }
}
MangoHubGivePatientConsentResponse.discriminator = undefined;
MangoHubGivePatientConsentResponse.attributeTypeMap = [
    {
        "name": "hasPatientConsent",
        "baseName": "hasPatientConsent",
        "type": "boolean"
    }
];
//# sourceMappingURL=mangoHubGivePatientConsentResponse.js.map